import styles from "../../styles/pages/auth/ForgotPassword.module.css";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaLock, FaArrowLeft } from "react-icons/fa";
import PageSeo from "../../components/common/PageSeo";
import api from "../../utils/api/axiosInstance"; // ✅ shared axios instance

const API_FORGOT_PASSWORD = "/authuser/forgot-password";

const ForgotPasswordPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState(""); // "success" | "error"
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setMessageType("");
    setLoading(true);

    try {
      await api.post(API_FORGOT_PASSWORD, { email });
      setMessage("If your email is registered, a reset link has been sent.");
      setMessageType("success");
    } catch (err) {
      setMessage("Something went wrong. Please try again later.");
      setMessageType("error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pageContainer">
      <PageSeo
        title="Forgot Password"
        description="Reset your Simpary account password."
        pathname="/forgot-password"
        noIndex
      />
      <div className="innerContainer">
        <div className={styles.loginContainer}>
          <div className={styles.loginhWrapper}>
            <div className={styles.authBox}>
              <FaLock size={50} />
              <h2>Forgot Password?</h2>
              <p>Please enter your email and we'll send you a reset link.</p>

              <form className="FieldForm" onSubmit={handleSubmit}>
                <input
                  type="email"
                  name="email"
                  placeholder="Enter your email"
                  aria-label="Email address"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={loading}
                />

                <button
                  type="submit"
                  className="buttonPrimary"
                  disabled={loading}
                >
                  {loading ? "Sending..." : "Send Reset Link"}
                </button>
              </form>

              {message && (
                <p
                  role={messageType === "error" ? "alert" : "status"}
                  aria-live={messageType === "error" ? "assertive" : "polite"}
                  className={
                    messageType === "success" ? styles.success : styles.error
                  }
                >
                  {message}
                </p>
              )}

              <button
                onClick={() => navigate("/login?mode=login")}
                className={styles.backLink}
              >
                <FaArrowLeft />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
